<template>
    <div>
        <div :title="name" v-if="!dropdown" class="sidebar-link">
            <router-link :to="to">
            <span>
                <slot></slot>
                <span class="link-name">{{ name }}</span>
            </span>
            </router-link>
        </div>
        <div :title="name" v-else class="sidebar-dropdown">
            <a @click="toggleDropdown">
                <span>
                    <slot></slot>
                    <span class="link-name">{{ name }}</span>
                </span>
                <transition name="custom-classes-transition"
                            enter-active-class="animate__animated animate__fadeIn"
                            leave-active-class="animate__animated animate__fadeOut">
                    <svg-icon icon="chevron-down-light" v-if="!toggle"></svg-icon>
                    <svg-icon icon="chevron-up-light" v-else></svg-icon>
                </transition>
            </a>
            <transition name="custom-classes-transition"
                        enter-active-class="animate__animated animate__fadeIn">
                <ul class="sidebar-dropdown-links" v-if="toggle">
                    <li v-for="(link, index) in links" :key="index">
                        <router-link :to="link.to" class="dropdown-link">{{ link.name }}
                        </router-link>
                    </li>
                </ul>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: 'sidebar-link',
    props: {
        name: {
            type: String,
            required: true,
        },
        to: {
            type: String,
        },
        dropdown: {
            type: Boolean,
            default: false,
        },
        links: {
            type: Array,
        }

    },
    data() {
        return {
            toggle: false,
        }
    },
    methods: {
        /**
         * Abre ou fecha um dropdown
         */
        toggleDropdown() {
            this.toggle = !this.toggle;
        }
    }
}
</script>

<style lang="scss">
.sidebar-nav {
    .sidebar-link {
        @apply w-full;
        -webkit-transition: .5s cubic-bezier(.685, .0473, .346, 1);
        transition: .5s cubic-bezier(.685, .0473, .346, 1);

        &:first-child > a {
            margin: 0 17px;
        }

        a, button {
            @apply relative flex justify-between cursor-pointer py-4 py-3 mt-3 mx-5 mb-0;

            span {
                @apply flex items-center text-white text-xs font-semibold uppercase;
                -webkit-transition: .5s cubic-bezier(.685, .0473, .346, 1);
                transition: .5s cubic-bezier(.685, .0473, .346, 1);

                .icon {
                    @apply h-6 w-6 mr-2 text-white;
                }

                .link-name {
                    @apply opacity-100 whitespace-no-wrap;
                    -webkit-transform: translateZ(0);
                    transform: translateZ(0);
                }
            }

            svg.sidebar-link-caret {
                @apply w-2 ml-auto;
            }
        }

        & > a.router-link-active {
            &:before {
                @apply absolute bg-white rounded-full;
                content: "";
                height: 6px;
                width: 6px;
                top: 22px;
                left: -13px;
            }
        }
    }

    .sidebar-dropdown {
        @apply w-full text-white;
        -webkit-transition: .5s cubic-bezier(.685, .0473, .346, 1);
        transition: .5s cubic-bezier(.685, .0473, .346, 1);

        &:first-child > a {
            margin: 0 17px;
        }

        a, button {
            @apply relative flex justify-between cursor-pointer py-4 py-3 mt-3 mx-5 mb-0 text-white;

            span {
                @apply flex items-center text-white text-xs font-semibold uppercase;
                -webkit-transition: .5s cubic-bezier(.685, .0473, .346, 1);
                transition: .5s cubic-bezier(.685, .0473, .346, 1);

                .icon {
                    @apply h-6 w-6 mr-2 text-white;
                }

                .link-name {
                    @apply opacity-100 whitespace-no-wrap;
                    -webkit-transform: translateZ(0);
                    transform: translateZ(0);
                }
            }

            svg.sidebar-link-caret {
                @apply w-2 ml-auto;
            }
        }

        .sidebar-dropdown-links {
            @apply block opacity-100 list-none;

            .dropdown-link {
                @apply p-1 mt-2 ml-5 text-white font-semibold text-xs uppercase whitespace-no-wrap;
            }
        }

    }

}
</style>
